import { combineReducers } from "redux";
import manage_wallet_history from "../features/admin/manage_wallet_history/Slice";

const ManageWalletHistory = combineReducers({
  manage_wallet_history: manage_wallet_history,
});

export default ManageWalletHistory;
